import $http from "../http";
import { baseUrl } from "../url";
const BASEURL = baseUrl.primary + "/v2";

const SetPointMeal = {
  getSetPointMealList() {
    return $http({
      method: "get",
      url: `${BASEURL}/Point/PointProductPage`,
    });
  },
  getPointProductList() {
    return $http({
      method: "get",
      url: `${BASEURL}/Point/PutMarkProductList`,
    });
  },
  createVipOrder(data) {
    return $http({
      method: "post",
      url: `${BASEURL}/Main/Order/CreateVipOrder`,
      data,
    });
  },
  createPointOrder(data) {
    return $http({
      method: "post",
      url: `${BASEURL}/Main/Order/CreatePointOrder`,
      data,
    });
  },
  createResumeOrder(data) {
    return $http({
      method: "post",
      url: `${BASEURL}/Main/Order/CreateResumeOrder`,
      data,
    });
  },
  checkPayState(params) {
    return $http({
      method: "get",
      url: `${BASEURL}/Main/Order/CheckPayState`,
      params,
    });
  },
};

export default SetPointMeal;
